import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import { CUSTOM_SETTINGS } from "constants/.";

class ReceiptReturnSearch extends React.Component<IFilter> {
  public static getInputQuery = (value) => {
    const Q = new FilterGenerator();

    Q.and("ReceiptId", value);
    Q.or("OtherRelation/Name", value);
    Q.or("Order/Number", value);

    return Q.query;
  };

  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();

    if (!_.isEmpty(f.receiptDate)) {
      Q.and("ReceiptDate", f.receiptDate, "dateRange");
    }
    if (!_.isEmpty(f.date)) {
      Q.and("Date", f.date, "dateRange");
    }
    Q.and("ReceiptId", f.receiptNumber);
    Q.and("OtherRelation/Name", f.counterpartyName);
    Q.and("Order/Number", f.orderNumber);
    Q.and("RoleId", f.type, "select");
    Q.and("OtherRelation/Number", f.counterpartyNumber);
    Q.and("Seller/Name", f.grower);
    Q.and("Supplier/Name", f.prefferedGrower);

    return Q.query;
  };

  public render = () => {
    const { filter, handleFilterChange, generateFilter, resetFilter, roleIds } =
      this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.receiptsReturns}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <div className="inner-block">
                <FormattedMessage id="PURCHASE_TYPE" tagName="label" />
                <Select
                  options={roleIds}
                  selectedOption={filter.type}
                  onChange={(value) => handleFilterChange(value, "type")}
                  className="min-width-select-forms"
                />
              </div>
              <Input
                label="COUNTERPARTY_NUMBER"
                value={filter.counterpartyNumber}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "counterpartyNumber")
                }
              />
            </div>
            <div className="filter-row">
              <RangeDatepicker
                name="date"
                label="DOCUMENT_DATE"
                value={filter.date}
                handleRangeChange={handleFilterChange}
              />
              <RangeDatepicker
                name="receiptDate"
                label="RECEIPTS_DATE"
                value={filter.receiptDate}
                handleRangeChange={handleFilterChange}
              />
            </div>
            <div className="filter-row">
              <Input
                label="GROWER"
                value={filter.grower}
                onChange={(e) => handleFilterChange(e.target.value, "grower")}
              />
              <Input
                label="PREFERRED_GROWER"
                value={filter.prefferedGrower}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "prefferedGrower")
                }
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="DELIVERIES_NR"
            value={filter.receiptNumber}
            onChange={(e) =>
              handleFilterChange(e.target.value, "receiptNumber")
            }
          />
          <Input
            label="COUNTERPARTY_NAME"
            value={filter.counterpartyName}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterpartyName")
            }
          />
        </div>
        <div className="filter-row">
          <Input
            label="ORDERS_NUMBER"
            value={filter.orderNumber}
            onChange={(e) => handleFilterChange(e.target.value, "orderNumber")}
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "RECEIPTS_SEARCH",
  pageName: CUSTOM_SETTINGS.receiptsReturns,
})(ReceiptReturnSearch);
